import { h } from "vue";
//#region src/components/tools/node.vue
var _sfc_main = {
	name: "DtcNode",
	props: {
		template: {
			type: String,
			required: true
		},
		library: {
			type: Object,
			default: () => {}
		},
		scope: {
			type: Object,
			default: () => ({})
		}
	},
	render(props) {
		return h({
			components: props.library,
			data() {
				return { ...props.scope };
			},
			template: props.template
		});
	}
};
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=node.vue.js.map